var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#EB0029"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3183 7.82538L5.41669 5.41663L12.2064 22.75L21.6667 11.0562L18.3183 7.82538ZM18.1107 8.88673L20.0842 10.7898L14.6864 11.7815L18.1107 8.88673ZM7.82478 6.79598L13.5142 11.5832L17.1235 8.53186L7.82478 6.79598ZM13.1087 12.4298L12.1813 20.2109L7.17934 7.44017L13.1087 12.4298ZM19.9444 11.7446L13.9674 12.8429L13.0885 20.2191L19.9444 11.7446Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/trx.ac88dece6c179f55752381df663ffd59.svg";
export { ForwardRef as ReactComponent };